import type { GroceryListStatus } from './display';

/**
 * Query keys for the groceries screens, all under a single `groceries`
 * prefix so `invalidateQueries({ queryKey: groceryKeys.all })` refreshes the
 * list and every open detail view together.
 */
export const groceryKeys = {
  all: ['groceries'] as const,
  list: (query: { status?: GroceryListStatus | undefined; limit?: number | undefined }) =>
    ['groceries', 'list', query] as const,
  detail: (id: string) => ['groceries', 'detail', id] as const,
  checkoffDefaults: (
    listId: string,
    itemId: string,
    productId: string | null,
    qty: number,
    unit: string,
  ) => ['groceries', 'checkoffDefaults', listId, itemId, productId, qty, unit] as const,
  /** Store price history for one product — shared data, keyed independently of any list. */
  priceHistory: (storeId: string, productId: string) =>
    ['groceries', 'priceHistory', storeId, productId] as const,
};
